import styled from 'styled-components'
import { Tabs } from 'antd'

const StyledTabs = styled(Tabs)`
  &.ant-tabs {
    .ant-tabs-tab {
      width: 144px;
      display: flex;
      justify-content: center;
      padding-bottom: 4px;
      color: ${p => p.theme.darkGrey500};
    }

    .ant-tabs-nav,
    .ant-tabs > div > .ant-tabs-nav {
      margin-bottom: 0px !important;
    }

    .ant-tabs-tab + .ant-tabs-tab {
      margin-left: 0;
    }

    .ant-tabs-tab .ant-tabs-tab-btn {
      font-size: 15px;
    }

    .ant-tabs-tab:hover,
    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
      color: ${p => p.theme.primary};
    }

    .ant-tabs-ink-bar {
      background: ${p => p.theme.primary};
    }
  }
`

export default StyledTabs
